import EnterPin from './EnterPin.jsx';

export default EnterPin;